'use strict';
import * as $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fcheckbox$002fcheckbox$002ejs from "@awesome.me/webawesome/dist/components/checkbox/checkbox.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent from "./io.github.nguyenyou.webawesome.laminar.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
  $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__(this, "wa-checkbox");
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ as $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$.prototype = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_Checkbox$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ as $h_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ };
$h_Lio_github_nguyenyou_webawesome_laminar_Checkbox$.prototype = $p;
$p.cQ = (function() {
  return $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fcheckbox$002fcheckbox$002ejs;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$, "io.github.nguyenyou.webawesome.laminar.Checkbox$", ({
  jP: 1,
  bp: 1,
  bo: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ as $d_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_Checkbox$;
function $m_Lio_github_nguyenyou_webawesome_laminar_Checkbox$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_Checkbox$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ = new $c_Lio_github_nguyenyou_webawesome_laminar_Checkbox$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_Checkbox$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ as $m_Lio_github_nguyenyou_webawesome_laminar_Checkbox$ };
